import { App } from 'antd';
import type { ReactNode } from 'react';

/**
 * Tuỳ chọn của toast có nút hành động (ví dụ "Gán lại vai trò"). Toast có nút
 * **không tự tắt**: ba giây không đủ để đọc rồi bấm. `khoa` để phía gọi đóng
 * đúng toast đó khi nút được bấm (`dong(khoa)`).
 */
export interface TuyChonToast {
  hanhDong?: ReactNode;
  khoa?: string;
}

/**
 * Thông báo nổi (§9.10).
 *
 * Vị trí (`bottomRight`) và `duration: 3` được cấu hình **một lần** trên
 * `<AntdApp>` trong providers. ❌ Không bao giờ dùng `alert()`.
 *
 * Quy ước câu chữ: toast là lời xác nhận ở thể đã hoàn tất — `Đã lưu thay đổi`,
 * `Đã thêm model AI.` (§10.2).
 */
export function useToast() {
  const { notification } = App.useApp();
  const tuyChon = (c: string, tc?: TuyChonToast) => ({
    message: c,
    ...(tc?.khoa ? { key: tc.khoa } : {}),
    ...(tc?.hanhDong ? { actions: tc.hanhDong, duration: 0 } : {}),
  });
  return {
    success: (c: string, tc?: TuyChonToast) => notification.success(tuyChon(c, tc)),
    error: (c: string, tc?: TuyChonToast) => notification.error(tuyChon(c, tc)),
    info: (c: string, tc?: TuyChonToast) => notification.info(tuyChon(c, tc)),
    warning: (c: string, tc?: TuyChonToast) => notification.warning(tuyChon(c, tc)),
    dong: (khoa: string) => notification.destroy(khoa),
  };
}
